import { useClientPortalAPI } from "@certn/api";
import { Loader, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Markdown } from "./Markdown";
import { useScrollToHashLocation } from "./hooks";

export function Intro() {
  const { apiConfigurationID = "" } = useParams();
  const { data, isLoading, error } = useClientPortalAPI(
    `/api/internal/client-portal/public-api/documentation/intro/`,
    {
      public_api_configuration: apiConfigurationID,
    }
  );
  useScrollToHashLocation(data?.markdown);
  const { t } = useTranslation();
  if (isLoading) {
    return <Loader />;
  }
  if (error) {
    return (
      <SectionMessage
        sectionTitle={t("There was a problem loading API documentation")}
        type="danger"
      >
        {error}
      </SectionMessage>
    );
  }
  return <Markdown testId="api-docs-intro">{data?.markdown || ""}</Markdown>;
}
